// assets.
import { ImageHero, IconHabi } from "@assets";

// styles
import { BodyWrapper } from "./styles";
import { ButtonGoogle } from "@shared/GoogleLoginButton/ButtonLoginGoogle";
import { GoogleOAuthProvider } from "@react-oauth/google";

export const LoginPage = () => {
  return (
    <>
      <div className="d-flex">
        <ImageHero style={{ height: "100vh" }} />
        <div className="d-flex align-items-center justify-content-center w-100">
          <div>
            <div className="d-flex justify-content-center mb-5">
              <IconHabi />
            </div>

            <BodyWrapper className="d-flex flex-column gap-2 align-items-center justify-content-center">
              <div className="first-subtitle">
                Aprobologos y aprobación de publicación
              </div>
              <h1 className="second-subtitle text-center">
                Inicia sesión con tu <br /> cuenta Google
              </h1>
              {process.env.ENV_AUTH_GOOGLE_API_KEY ? (
                <GoogleOAuthProvider
                  clientId={process.env.ENV_AUTH_GOOGLE_API_KEY}
                >
                  <ButtonGoogle />
                </GoogleOAuthProvider>
              ) : (
                <div className="text-danger">
                  No se ha encontrado la clave de autenticación
                </div>
              )}
            </BodyWrapper>
          </div>
        </div>
      </div>
    </>
  );
};
